<template lang="pug">
  ul.ods-actions-menu__ul.ods-actions-menu--user__ul
    li.user-ul__user-name
      | {{ fullName }}
    li.ods-actions-menu__separator
    li
      lang-selector(
        cssClass="user-ul__languages"
        :mobile="isMobile")
    li.ods-actions-menu__separator
    li(@click="handleClose", style="cursor: pointer")
      ods-icon(name="logout")
      | {{ this.$t('loyalty.logout') }}
</template>

<script>
import LangSelector from '@/components/shared/LangSelector'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'UserMenu',
  components: {
    LangSelector
  },

  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    }),
    fullName () {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      return `${storageAppData.name} ${storageAppData.surname1} ${storageAppData.surname2}`
    }
  },

  methods: {
    ...mapActions(['closeSession']),
    handleClose () {
      this.$store.dispatch('logout')
    }
  }
}
</script>
